import { render } from "./QuittanceItem.vue?vue&type=template&id=080f3423"
import script from "./QuittanceItem.vue?vue&type=script&lang=js"
export * from "./QuittanceItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__